// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ConversationIcon = require("../../../reason/conversations/components/ConversationIcon.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function ConversationsEmptyState(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ConversationIcon.make, {
          size: 120
        }),
        className: "text-center mt-[5vh] text-gray-400"
      }),
      JsxRuntime.jsx("div", {
        children: "You don't have any conversations yet",
        className: "text-center font-semibold text-gray-700 text-3xl"
      }),
      JsxRuntime.jsx("div", {
        children: "When you send or receive private messages regarding properties, buyer needs or broadcast messages they will appear here.",
        className: "text-center text-xl"
      }),
      JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          size: "large",
          children: "Learn more"
        }),
        className: "hover:no-underline",
        href: "https://intercom.help/top-agent-network/en/articles/3447060-new-conversations-on-tan",
        rel: "noreferrer noopener",
        target: "_blank"
      })
    ],
    className: "flex flex-col items-center justify-center w-screen max-w-lg mx-auto gap-5"
  });
}

let make = ConversationsEmptyState;

exports.make = make;
/* ButtonsV5 Not a pure module */
